import React, { Component } from 'react'
import { Auth } from 'aws-amplify'

export default class CreateAs extends Component {
	constructor(props) {
		super(props)
		this.state = {}
		// this.presser = this.presser.bind(this)
	}

	async componentDidMount() { }

	render() {
		const { data } = this.props
		return (
			<div style={{ flexDirection: 'row' }}>
				<details open=''>
					<summary>Create Content As</summary>

					<div>
						<input
							type='radio'
							checked={data.createAs == 'YouSay Editor'}
							disabled={data.editContent ? true : false}
							onChange={() => {
								this.props.handleCreateAs('YouSay Editor')
							}}
						></input>
						<text>YouSay Editor</text>
					</div>
					{Auth.user.attributes && Auth.user.attributes.email ? (
						<div>
							<input
								type='radio'
								checked={data.createAs == 'user'}
								disabled={data.editContent ? true : false}
								onChange={() => {
									this.props.handleCreateAs('user')
								}}
							></input>
							<text>User</text>
						</div>
					) : null}

					<div>
						<input
							type='radio'
							checked={data.createAs == 'other'}
							disabled={data.editContent ? true : false}
							onChange={() => {
								this.props.handleCreateAs('other')
							}}
						></input>
						<text>Choose Contributor</text>
					</div>
					{data.createAs == 'other' ? (
						<div>
							{data.usersList.map((user, userIndex) => {
								return (
									<div key={userIndex}>
										{user ? (
											<div>
												<input
													type='radio'
													checked={
														data.selectedContributor && data.selectedContributor.name == user.name
													}
													disabled={data.editContent ? true : false}
													onChange={() => {
														this.props.handleSelectContributor(user)
													}}
												></input>
												<text>{user.handle}</text>
											</div>
										) : null}
									</div>
								)
							})}
						</div>
					) : null}
					{/* {data.selectedContentType != 'Job' ? ( */}
					<div>
						<div>
							<label>Choose Planner</label>
						</div>
						<div class='plannersList'>
							{data.plannersList && data.plannersList.map((user, userIndex) => {
								return user ? (
									<div key={userIndex}>
										<input
											type='radio'
											checked={
												data.selectedContentPlanner && data.selectedContentPlanner.name == user.name
											}
											disabled={data.editContent ? true : false}
											onChange={() => {
												this.props.handleSelectContentPlanner(user)
											}}
										></input>
										<text>{user.handle}</text>
									</div>
								) : null
							})}
						</div>
					</div>
					{/* ) : null} */}
				</details>
			</div>
		)
	}
}
